import type { FunctionComponent, ReactNode } from "react";
import { useAuth } from "@clerk/react";
import { authStyles, CLERK_ENABLED } from "./authStyles";
import { SignInPrompt } from "./SignInPrompt";

interface Props {
  readonly children: ReactNode;
  readonly message?: string;
}

const ClerkProtectedRoute: FunctionComponent<Props> = ({ children, message }) => {
  const { isSignedIn, isLoaded } = useAuth();

  if (!isLoaded) {
    return (
      <div style={authStyles.loadingContainer}>
        <div style={authStyles.loadingSpinner} />
        <span style={authStyles.loadingText}>Loading...</span>
      </div>
    );
  }

  if (!isSignedIn) {
    return <SignInPrompt message={message} />;
  }

  return <>{children}</>;
};

export const ProtectedRoute: FunctionComponent<Props> = ({ children, message }) => {
  if (!CLERK_ENABLED) return <>{children}</>;
  return <ClerkProtectedRoute message={message}>{children}</ClerkProtectedRoute>;
};
